import { render, staticRenderFns } from "./PhotographyAppointmentDetail.vue?vue&type=template&id=023d27e1&scoped=true&"
import script from "./PhotographyAppointmentDetail.vue?vue&type=script&lang=js&"
export * from "./PhotographyAppointmentDetail.vue?vue&type=script&lang=js&"
import style0 from "./PhotographyAppointmentDetail.vue?vue&type=style&index=0&id=023d27e1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023d27e1",
  null
  
)

export default component.exports